module.exports = __webpack_public_path__ + "static/media/IMG_3923.78948399.JPG";